import { useInvoiceWireTransferActivationStatusQuery } from 'modules/company/general-settings';
import { type QueryState } from 'src/core/api/queryState';

export const useIsInvoiceWireTransferActivatedQuery =
  (): QueryState<boolean> => {
    const wireTransferActivationStatusQueryState =
      useInvoiceWireTransferActivationStatusQuery();

    if (wireTransferActivationStatusQueryState.status === 'success') {
      return {
        ...wireTransferActivationStatusQueryState,
        data: wireTransferActivationStatusQueryState.data.isActivated,
      };
    }

    return wireTransferActivationStatusQueryState;
  };
